import React from "react";
import "./NoticeBoard.css";

export default function NoticeBoard() {
  const notices = [
    "📢 Friday Khutbah: 1:30 PM",
    "📢 Quran Class every Saturday",
    "📢 Community Iftar: 25th Dec",
  ];

  return (
    <section className="notice-board">
      <h2>Announcements</h2>
      <div className="notice-list">
        {notices.map((notice, index) => (
          <div key={index} className="notice-item">
            {notice}
          </div>
        ))}
      </div>
    </section>
  );
}
